<template>
    <div
        :id="id"
        class="modal fade"
        role="dialog"
        tabindex="-1">
        <div
            class="modal-dialog modal-lg"
            role="document">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalContainer',
    props: {
        id: {
            type: String,
            default: 'modal',
        },
    },
};
</script>
